import { FormEvent, useEffect, useState } from 'react';
import { getApiErrorMessage, portalApi } from '../../api/client';
import type { TeamMember } from '../../api/types';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';

export function TeamPage() {
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [form, setForm] = useState({ email: '', password: '', role: 'developer', full_name: '' });
  const [err, setErr] = useState('');

  const load = () => void portalApi.listTeam().then((r) => setMembers(r.members ?? []));

  useEffect(() => {
    load();
  }, []);

  const onCreate = async (e: FormEvent) => {
    e.preventDefault();
    setErr('');
    try {
      await portalApi.createTeamMember(form);
      setForm({ email: '', password: '', role: 'developer', full_name: '' });
      load();
    } catch (ex) {
      setErr(getApiErrorMessage(ex));
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <h2 className="font-display text-2xl">Team & roles</h2>
      <p className="text-sm text-onyx-muted">
        Owner — full access · Developer — API & webhooks · Finance — payouts & reports
      </p>
      {err ? <p className="text-sm text-onyx-danger">{err}</p> : null}
      <Card title="Members">
        <ul className="divide-y divide-onyx-border">
          {members.map((m) => (
            <li key={m.id} className="py-3 flex justify-between items-center text-sm">
              <div>
                <p className="font-medium">{m.email}</p>
                <p className="text-onyx-muted text-xs capitalize">{m.role}</p>
              </div>
              {m.totp_enabled ? <Badge status="active" /> : <span className="text-xs text-onyx-muted">2FA off</span>}
            </li>
          ))}
        </ul>
      </Card>
      <Card title="Invite sub-account">
        <form onSubmit={onCreate} className="space-y-3">
          <Input placeholder="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <Input placeholder="Full name" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
          <Input placeholder="Password" type="password" minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          <select className="input-field" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
            <option value="developer">Developer</option>
            <option value="finance">Finance</option>
          </select>
          <Button type="submit">Create account</Button>
        </form>
      </Card>
    </div>
  );
}
